import React from "react";
import GridLayout from "../GridLayout";
export default ({ schema, data, layout, ...rest }) => {
  return (
    <GridLayout layout={layout} {...rest}>
      {schema.map((s, i) => {
        const { key, render } = s;
        if (typeof render === "function") {
          return render(data[key], data, i);
        }
        return data[key];
      })}
    </GridLayout>
  );
};

export const DefaultColumnLayout = `
..
..
`;
